import React from 'react';

export default function GalleryGridConfig({ data, onChange }) {
  const images = data.images || [];

  const updateImage = (index, field, value) => {
    const newImages = [...images];
    newImages[index] = { ...newImages[index], [field]: value };
    onChange({ ...data, images: newImages });
  };

  const addImage = () => {
    const size = images.length === 0 ? 'large' : 'small';
    onChange({ ...data, images: [...images, { src: '', alt: '', size }] });
  };

  const removeImage = (index) => {
    onChange({ ...data, images: images.filter((_, i) => i !== index) });
  };

  return (
    <>
      <div className="adminblog-field">
        <label>Images ({images.length})</label>
        <p className="adminblog-field-hint">First image should be "large". Others "small".</p>
        {images.map((img, i) => (
          <div key={i} className="adminblog-list-item">
            <select value={img.size} onChange={(e) => updateImage(i, 'size', e.target.value)} style={{ width: 70, padding: '6px 4px', fontSize: 11, borderRadius: 4, border: '1px solid #e5e5e5' }}>
              <option value="large">Large</option>
              <option value="small">Small</option>
            </select>
            <input type="text" value={img.src} onChange={(e) => updateImage(i, 'src', e.target.value)} placeholder="Image URL" />
            <button className="adminblog-list-remove" onClick={() => removeImage(i)}>×</button>
          </div>
        ))}
        <button className="adminblog-list-add" onClick={addImage}>+ Add Image</button>
      </div>
    </>
  );
}
